import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Modal from "../AdDetails/Modal";
import ContactInfoModal from "./ContactInfoModal";
import {
  cardHover,
  cardOutline,
  fonts,
  headingFonts,
  primaryButtonStyles,
} from "../../Styles/Styles";

export default function ServicesCard({ service, serviceProviderId }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const loggedInUser = JSON.parse(localStorage.getItem("user"));

  // Check if the current URL matches `/expert/:id`
  const isExpertRoute = /^\/expert\/\w+/.test(location.pathname);

  const handleViewServiceClick = (serviceId) => {
    navigate(`/service/${serviceId}`);
  };

  const handleBookNow = () => {
    if (loggedInUser) {
      setOpen(true);
    } else {
      setShowModal(true); // Show the modal if the user is not logged in
    }
  };

  const closeModal = () => {
    setShowModal(false); // Function to close the modal
  };

  return (
    <>
      <Card
        sx={{
          height: "100%",
          maxWidth: "auto",
          position: "relative",
          ...cardOutline,
          ...cardHover,
        }}
      >
        <CardMedia
          sx={{ height: 180, cursor: "pointer" }}
          image={service.image}
          title={service.name}
          onClick={() => handleViewServiceClick(service._id)}
        />
        <CardContent>
          <Typography
            gutterBottom
            variant="body1"
            onClick={() => handleViewServiceClick(service._id)}
            sx={{
              ...headingFonts,
              display: "inline",
              cursor: "pointer",
              color: "var(--primary-color)",
              "&:hover": { color: "inherit" },
            }}
          >
            <strong>{service.name}</strong>
          </Typography>
          <Typography
            variant="body2"
            sx={{ ...fonts, color: "text.secondary" }}
          >
            {service.description}
          </Typography>
        </CardContent>
        {isExpertRoute && (
          <CardActions
            sx={{
              pl: 2, // Add padding to the right if needed
              marginTop: "-10px",
              justifyContent: "flex-start", // Align items to the right
            }}
          >
            <Button
              size="small"
              variant="contained"
              onClick={handleBookNow}
              sx={{ ...primaryButtonStyles }}
            >
              Book Now
            </Button>
          </CardActions>
        )}
      </Card>
      <ContactInfoModal
        open={open}
        setOpen={setOpen}
        onClose={() => setOpen(false)}
        service={service}
        serviceProviderId={serviceProviderId}
      />
      <Modal open={showModal} onClose={closeModal} />
    </>
  );
}
